// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__37E5Q","right":"styles_right__3pVcO"};